import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PropertyGroup } from './models/template.model';

@Injectable()
export class PropertyGroupService implements OnDestroy {
  onUpdatePropertyGroups$: Observable<PropertyGroup[]>;

  private _onUpdatePropertyGroups = new BehaviorSubject([]);

  groupName = 1;

  constructor() {
    this.onUpdatePropertyGroups$ = this._onUpdatePropertyGroups.asObservable();
  }

  ngOnDestroy(): void {
    this._onUpdatePropertyGroups.complete();
  }

  setReportPropertyGroups(propertyGroups: PropertyGroup[]) {
    this._onUpdatePropertyGroups.next(propertyGroups);
  }

  getReportPropertyGroupsStream(): Observable<PropertyGroup[]> {
    return this.onUpdatePropertyGroups$;
  }

  getReportPropertyGroups(): PropertyGroup[] {
    return this._onUpdatePropertyGroups.getValue();
  }
}
